import { useConfig } from '@/composables';

const remoteHazardAssetsUrl = useConfig().value.remoteHazardAssets.iconAssetsPathSvg;

export const CLOSURE_HAZARD_ICONS = {
  'ew-airport-closure': `${remoteHazardAssetsUrl}/ew-airport-closure.svg?url`,
  'ew-airspace-closure': `${remoteHazardAssetsUrl}/ew-airspace-closure.svg?url`,
  'ew-facility-or-park-closure': `${remoteHazardAssetsUrl}/ew-facility-or-park-closure.svg?url`,
  'ew-other-bridge-closure': `${remoteHazardAssetsUrl}/ew-other-bridge-closure.svg?url`,
  'ew-other-closure': `${remoteHazardAssetsUrl}/ew-other-closure.svg?url`,
  'ew-park-closure': `${remoteHazardAssetsUrl}/ew-park-closure.svg?url`,
  'ew-road-closure': `${remoteHazardAssetsUrl}/ew-road-closure.svg?url`,
  'ew-school-closure': `${remoteHazardAssetsUrl}/ew-school-closure.svg?url`,
};
